// extracted by mini-css-extract-plugin
module.exports = {"warningLink":"AgeVerificationBanner_warningLink__Chbm7"};